export default __webpack_public_path__ + "static/media/new-hotels.23b4de76.svg";